"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listRegions = void 0;
const listRegions = ({ httpClient, }) => ({ page = 1, per_page = 25, }) => {
    const path = '/regions';
    const query_params = { page, per_page };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listRegions = listRegions;
//# sourceMappingURL=list-regions.js.map